import React from "react"
import { twMerge } from "tailwind-merge"

type TextInputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  className?: string
}

export const TextInput = React.forwardRef<HTMLInputElement, TextInputProps>(
  ({ className, type = "text", ...props }, ref) => {
    return (
      <input
        ref={ref}
        type={type}
        className={twMerge(
          "block w-full  border-bottom border-gray-150 bg-white",
          "px-3 py-3 text-base text-black placeholder:text-gray-200",
          "focus:outline-none focus:border-gray-250",
          "disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-400",
          className,
        )}
        {...props}
      />
    )
  },
)

TextInput.displayName = "TextInput"
